import React from 'react'
import AutocompleteFetch from '@/javascript/presentation/components/inputs/autocomplete-fetch-input'
import { ResourcePlaceData } from '@/javascript/presentation/view-models'

type Props = {
  resourcePlaces: ResourcePlaceData[]
  setResourcePlaces: React.Dispatch<React.SetStateAction<ResourcePlaceData[]>>
  fetchResourcePlaces: (searchText?: string) => Promise<ResourcePlaceData[]>
  autocompleteFetchProps?: Partial<React.ComponentProps<typeof AutocompleteFetch>>
  optionsProps?: {
    tooltipTitle: string
    disable?: (option: ResourcePlaceData) => boolean
  }
}

const ResourcePlacesInput: React.FC<Props> = ({
  resourcePlaces, setResourcePlaces, fetchResourcePlaces, autocompleteFetchProps, optionsProps
}) => {
  return (
    <AutocompleteFetch
      label="Clientes ou Locais" value={resourcePlaces} setValue={setResourcePlaces}
      fetchOptions={fetchResourcePlaces}
      optionsProps={optionsProps}
      getOptionDisabled={(option: ResourcePlaceData) => {
        return optionsProps?.disable ? optionsProps.disable(option) : false
      }}
      {...autocompleteFetchProps}
    />
  )
}

export default ResourcePlacesInput
